import { render, staticRenderFns } from "./chartsPoly.vue?vue&type=template&id=f0600274&scoped=true"
import script from "./chartsPoly.vue?vue&type=script&lang=js"
export * from "./chartsPoly.vue?vue&type=script&lang=js"
import style0 from "./chartsPoly.vue?vue&type=style&index=0&id=f0600274&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0600274",
  null
  
)

export default component.exports